import React from 'react'
import userToken from '@amzn/meridian-tokens/base/icon/user'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

interface IProfileIconProps {
    toggleProfile: () => void
}
/**
 * Displays Profile icon
 * Clicking the icon opens the bottom sheet with multiple options.
 *
 * Usage:
 * <ProfileIcon toggleProfile={toggleProfile} />
 *
 * @returns {React.ReactElement}
 */
const ProfileIcon = ({ toggleProfile }: Readonly<IProfileIconProps>): React.ReactElement => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Button type="icon" id={'profile'} data-testid={'Profile'} onClick={toggleProfile}>
            <Icon tokens={userToken}>{t(bundle, 'jsma-web-common-profile')}</Icon>
        </Button>
    )
}

export default ProfileIcon
